import React, { FC } from 'react'
import { CreateBoxLayout } from '../layout/CreateBoxLayout'
import { NewBoxForm } from '../components/NewBoxForm'

export const CreateMoneyPoolPage: FC = () => {
  return (
    <CreateBoxLayout>
      <NewBoxForm />
    </CreateBoxLayout>
  )
}

export const createMoneyPoolPagePath = '/create-money-pool'
